import React, { useState } from "react";
import { db } from "../firebase";
import { doc, setDoc, collection, query, where, getDocs, Timestamp } from "firebase/firestore";

function KioskRegister({ token, companyId, onRegistered }) {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!phone.match(/^[0-9]{10,11}$/)) {
      setError("電話番号は10〜11桁の数字で入力してください");
      return;
    }
    setSubmitting(true);
    try {
      // usersコレクションから電話番号で従業員を検索
      const q = query(
        collection(db, "users"),
        where("phone", "==", phone),
        where("companyId", "==", companyId || "")
      );
      const snap = await getDocs(q);
      if (snap.empty) {
        setError("この電話番号で登録された従業員が見つかりません。\n管理者に従業員登録を依頼してください。");
        setSubmitting(false);
        return;
      }

      const userData = snap.docs[0].data();
      if (userData.status === "pending") {
        setError("アカウントがまだ承認されていません。管理者に承認を依頼してください。");
        setSubmitting(false);
        return;
      }

      // kioskUsersにスマホ→uidのマッピングを保存
      await setDoc(doc(db, "kioskUsers", phone), {
        name: userData.name,
        phone,
        uid: userData.uid,
        companyId: userData.companyId || "",
        status: "approved", // 従業員登録済みなので即承認
        createdAt: Timestamp.now(),
      });

      localStorage.setItem("miyabi_kiosk_phone", phone);
      localStorage.setItem("miyabi_kiosk_name", userData.name);
      localStorage.setItem("miyabi_kiosk_status", "approved");
      localStorage.setItem("miyabi_kiosk_uid", userData.uid);

      onRegistered({ name: userData.name, phone, uid: userData.uid, status: "approved" });
    } catch (err) {
      setError("エラーが発生しました: " + err.message);
    }
    setSubmitting(false);
  };

  return (
    <div style={st.container}>
      <div style={st.box}>
        <div style={{ fontSize: "40px", textAlign: "center", marginBottom: "12px" }}>📱</div>
        <h2 style={st.title}>スマホ打刻の初回設定</h2>
        <p style={st.desc}>従業員登録済みの電話番号を入力してください。</p>
        <form onSubmit={handleSubmit}>
          <input
            style={st.input}
            type="tel"
            placeholder="電話番号（例：09012345678）"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            required
          />
          {error && <p style={{ color: "#e74c3c", fontSize: "14px", marginBottom: "8px", whiteSpace: "pre-line" }}>{error}</p>}
          <button style={st.btn} type="submit" disabled={submitting}>
            {submitting ? "確認中..." : "設定する"}
          </button>
        </form>
      </div>
    </div>
  );
}

const st = {
  container: { minHeight: "100vh", backgroundColor: "#f0f4f8", display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" },
  box: { backgroundColor: "#fff", padding: "36px 28px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", width: "100%", maxWidth: "360px" },
  title: { textAlign: "center", color: "#2c3e50", marginBottom: "8px" },
  desc: { textAlign: "center", color: "#7f8c8d", fontSize: "14px", lineHeight: "1.6", marginBottom: "24px" },
  input: { width: "100%", padding: "14px", marginBottom: "12px", border: "1px solid #ddd", borderRadius: "10px", fontSize: "16px", boxSizing: "border-box" },
  btn: { width: "100%", padding: "16px", backgroundColor: "#2c3e50", color: "#fff", border: "none", borderRadius: "10px", fontSize: "16px", cursor: "pointer" },
};

export default KioskRegister;
